<div class="bg-white text-center w-full mb-20 p-20 shadow-lg">
  <div class="flex items-center justify-center mb-10">
    <mat-icon class="mr-15">{{ data?.icon }}</mat-icon>
    <div class="subtitle-2 font-bold!">
      {{ data?.type === 'file' ? 'Quote / Invoice' : (data?.type | titlecase) }} Import folder
    </div>
  </div>
  <mat-divider></mat-divider>
  @if (!!data?.fileDirectory || !!data?.imageDirectory) {
    <div class="flex items-center justify-between mt-20">
      <div class="font-bold">{{ data?.type === 'image' ? data?.imageDirectory : data?.fileDirectory }}</div>
      <div class="flex items-center gap-x-10">
        <button matIconButton (click)="deleteDirectory.emit(data?.type)">
          <mat-icon>delete</mat-icon>
        </button>
        <button
          matButton="elevated"
          class="charcoal-button w-36! min-w-36! p-0!"
          type="button"
          (click)="setDirectory.emit(data?.type)">
          <mat-icon class="m-0!">create</mat-icon>
        </button>
      </div>
    </div>
  } @else {
    <button matButton="elevated" class="charcoal-button w-200 mt-20" (click)="setDirectory.emit(data?.type)">
      Set
    </button>
  }
</div>
